import React from "react";
import { connect } from "react-redux";
import { fromJS } from "immutable";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import { ShippingSection } from "MODULES/shared/components/ShippingSection";
import { validate } from "MODULES/SalesOrders/components/shared/FormSections/ShippingSection";
import * as actions from "MODULES/RejectedCores/actions";
import {
  COMPANY,
  DROPSHIP
} from "MODULES/shared/components/ShippingSection/shippingTypes";
import useRejectedCore from "../../../../hooks/useRejectedCore";

export function Form(props) {
  const rejectedCore = useRejectedCore();
  const shipToOptions = [
    {
      text: "Company",
      value: COMPANY
    },
    {
      text: "Other",
      value: DROPSHIP
    }
  ];

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <h4>Ship To</h4>
        <ShippingSection
          shippingType="ship_to"
          shipToOptions={shipToOptions}
          shipToCompany={fromJS(rejectedCore.ship_to_company)}
        />
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, {
  onSubmit: actions.update
})(
  form({
    form: "rejectedCoreShipToDetails",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/RejectedCores/components/Detail/ShipToForm.jsx